<template>
  <div class="container">
    <div class="row d-flex align-items-center">
      <div class="col d-flex justify-content-between">
        <div class="dropdown">
          <button
            class="btn btn-secondary dropdown-toggle btn-sm"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span v-if="account_name">{{ account_name }}</span>
            <span v-else>Account</span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li
              class="dropdown-item"
              v-for="a in store.accounts"
              :key="a.id"
              :class="{ 'bg-primary': store.active_account == a.id }"
              @click="selectAccount(a.id, a.name)"
            >
              {{ a.name }}
            </li>
          </ul>
        </div>
        <button
          class="btn btn-sm btn-success padding2"
          @click="setExpType('e')"
          v-if="txn_type == 'i' && account_name"
        >
          Income
        </button>
        <button
          class="btn btn-sm btn-danger padding2"
          @click="setExpType('i')"
          v-if="txn_type == 'e' && account_name"
        >
          Expense
        </button>
      </div>

      <div
        class="col-4 padding2 d-flex align-items-center justify-content-evenly"
        v-if="account_name"
      >
        <span
          class="badge rounded-pill bg-light text-dark"
          @click="toggleNote()"
          >Note</span
        >

        <span
          class="badge rounded-pill bg-light text-dark float-end"
          @click="toggleCamera()"
          ><i class="bi bi-camera"></i
        ></span>
      </div>
    </div>
    <div class="row border mt-1 d-flex align-items-center" v-if="showNote">
      <div class="col">
        <div class="textarea-wrapper">
          <textarea
            class="form-control"
            rows="2"
            placeholder="Note..."
            v-model.trim="note"
          ></textarea>
          <!-- <div class="camera-icon">
          <i class="bi bi-camera"></i>
        </div> -->
        </div>
      </div>
    </div>
    <div class="row" v-if="toggle_camera">
      <div class="col">
        <OpenCamera></OpenCamera>
      </div>
    </div>
    <div class="row d-flex align-items-center mt-1" v-if="account_name">
      <div class="col d-flex justify-content-center">
        <input
          type="date"
          id="txn_date"
          class="form-control date-field me2"
          placeholder="Date"
          :value="txn_date"
          @change="updateDate()"
        />
      </div>
      <div class="col d-flex justify-content-center">
        <input
          type="text"
          class="form-control fw-bold border border-2 padding2"
          :class="textColour"
          placeholder="₹"
          v-model.trim="textValue"
          @input="handleInput"
        />
      </div>
      <div class="col d-flex justify-content-center">
        <button class="btn btn-primary btn-sm" @click="addTxn()">Add</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "../../store/index";
import { updateDoc, doc } from "firebase/firestore";
import { auth, db } from "../../firebase/config";
import OpenCamera from "../camera/OpenCamera.vue";
const dayjs = require("dayjs");
import { ref, computed, onBeforeUnmount } from "vue";
const store = useStore();
const txn_type = ref("e");
const txn_date = ref(dayjs().format("YYYY-MM-DD"));
const account_id = ref("");
const account_name = ref("");
const showNote = ref(false);
const note = ref("");
const textValue = ref("");
const sortby = ref("desc");
const { customAlphabet } = require("nanoid");
const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const nanoid = customAlphabet(alphabet, 6);
const toggle_camera = ref(false);
onBeforeUnmount(() => {
  if (store.action == "") {
    //selectAccount("xkcd", "chonk");
    updateDB(""); //this is done to clear out selected account if entry is not made
  }
});
const toggleCamera = () => {
  toggle_camera.value = !toggle_camera.value;
};
const updateDate = () => {
  txn_date.value = document.getElementById("txn_date").value.trim();
};
const toggleNote = () => {
  showNote.value = !showNote.value;
};
const setExpType = (str) => {
  txn_type.value = str;
};
const selectAccount = (id, name) => {
  if (account_id.value != id) {
    account_id.value = id;
    account_name.value = name;
    updateDB(id);
    lastTxnType(id);
  } else {
    updateDB("");
    account_id.value = "";
    account_name.value = "";
    textValue.value = "";
    note.value = "";
  }
};
const updateDB = async (account_id) => {
  const userDocRef = doc(db, "users", auth.currentUser.uid);
  await updateDoc(userDocRef, {
    "settings.active_account": account_id,
  });
};
const lastTxnType = (id) => {
  var arr = [];
  store.accounts.forEach((account) => {
    if (account.id == id) {
      for (const property in account.journal) {
        arr.push({
          account_id: account.id,
          journal_id: property,
          ...account.journal[property],
        });
      }
    }
  });
  var sorted_arr = sortByField(arr, "d");
  if (sorted_arr.length) {
    setExpType(sorted_arr[0].t);
  }
};
function sortByField(arr, field) {
  if (sortby.value == "asc") {
    return arr.slice().sort((a, b) => {
      // Compare the values of the specified field
      if (a[field] > b[field]) {
        return 1;
      } else if (a[field] < b[field]) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  if (sortby.value == "desc") {
    return arr.slice().sort((a, b) => {
      // Compare the values of the specified field
      if (a[field] < b[field]) {
        return 1;
      } else if (a[field] > b[field]) {
        return -1;
      } else {
        return 0;
      }
    });
  }
}
const handleInput = () => {
  // Allow numbers, decimals, 'k', and 'l'
  const sanitized = textValue.value.replace(/[^0-9.kl]/gi, "");

  // Handle case for 'k' or 'l'
  if (/^\d*\.?\d+k$/i.test(sanitized)) {
    textValue.value = parseFloat(sanitized) * 1000; // Convert to numeric value
  } else if (/^\d*\.?\d+l$/i.test(sanitized)) {
    textValue.value = parseFloat(sanitized) * 100000; // Convert to numeric value
  } else {
    textValue.value = sanitized; // Remove invalid characters
  }
};
const textColour = computed(() => {
  var col = "";
  if (txn_type.value == "e") {
    col = "text-danger";
  }
  if (txn_type.value == "i") {
    col = "text-success";
  }
  return col;
});

const addTxn = async () => {
  var txnObj = {
    n: note.value, //note
    a: parseInt(textValue.value), //amount
    t: txn_type.value, //txn type - i:income, e:expense
    p: null, //link to photo, if any
    // ts: serverTimestamp(), //timestamp
    d: txn_date.value + " " + dayjs().format("HH:mm:ss"), //transaction date, with time (for sorting) - need not be present date, can be past or future
  };
  //console.log(txnObj);
  const accountRef = doc(db, "accounts", account_id.value);
  await updateDoc(accountRef, {
    ["journal." + nanoid()]: txnObj,
  });
  selectAccount(account_id.value);
};
</script>
<style scoped>
.padding2 {
  padding: 2px;
}
.textarea-wrapper {
  position: relative;
}

.camera-icon {
  position: absolute;
  top: -10px; /* Adjust as needed */
  right: -10px; /* Adjust as needed */
  background-color: white;
  padding: 1px;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.date-field {
  width: auto;
  min-width: 125px; /* Ensures a reasonable default width */
  padding: 0.1rem 0.1rem; /* Matches default form-control padding */
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}
</style>
